import { apiClient } from './api'

export type RaidType = 'risk' | 'assumption' | 'issue' | 'dependency'

export interface ProjectRAIDItem {
  id: number
  project_id: number
  raid_type: RaidType
  title: string | null
  description: string
  status: string | null
  owner: string | null
  due_date: string | null
  extra_metadata: Record<string, unknown> | null
  position: number
  created_at: string | null
  updated_at: string | null
}

export interface ProjectRAIDItemCreate {
  raid_type: RaidType
  title?: string | null
  description: string
  status?: string | null
  owner?: string | null
  due_date?: string | null
  extra_metadata?: Record<string, unknown> | null
  position?: number
}

export const projectRaidService = {
  list(projectId: number, type?: RaidType): Promise<ProjectRAIDItem[]> {
    const params = type ? { type } : {}
    return apiClient.get(`/api/v1/projects/${projectId}/raid/`, { params }).then((r) => r.data)
  },
  create(projectId: number, body: ProjectRAIDItemCreate): Promise<ProjectRAIDItem> {
    return apiClient.post(`/api/v1/projects/${projectId}/raid/`, body).then((r) => r.data)
  },
  get(projectId: number, itemId: number): Promise<ProjectRAIDItem> {
    return apiClient.get(`/api/v1/projects/${projectId}/raid/${itemId}`).then((r) => r.data)
  },
  update(projectId: number, itemId: number, body: Partial<ProjectRAIDItemCreate>): Promise<ProjectRAIDItem> {
    return apiClient.patch(`/api/v1/projects/${projectId}/raid/${itemId}`, body).then((r) => r.data)
  },
  delete(projectId: number, itemId: number): Promise<void> {
    return apiClient.delete(`/api/v1/projects/${projectId}/raid/${itemId}`)
  },
}
